/** LogicMatrices §1 base states 0–7 (Encompass). State 7 = Closed. */
export type LoanNavBaseState = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type LoanNavChipVariant =
  | "new"
  | "started"
  | "incomplete"
  | "application-received"
  | "processing"
  | "initial-approval"
  | "cleared-to-close"
  | "closed";

export interface LoanNavStatusDisplay {
  label: string;
  variant: LoanNavChipVariant;
}

const LOAN_NAV_STATUS_BY_BASE_STATE: Record<LoanNavBaseState, LoanNavStatusDisplay> = {
  0: { label: "New", variant: "new" },
  1: { label: "Started", variant: "started" },
  2: { label: "Incomplete", variant: "incomplete" },
  3: { label: "Application Received", variant: "application-received" },
  4: { label: "Processing", variant: "processing" },
  5: { label: "Initial Approval", variant: "initial-approval" },
  6: { label: "Cleared to Close", variant: "cleared-to-close" },
  7: { label: "Closed", variant: "closed" },
};

export const getLoanNavStatusDisplay = (baseState: LoanNavBaseState): LoanNavStatusDisplay =>
  LOAN_NAV_STATUS_BY_BASE_STATE[baseState];
